export default __webpack_public_path__ + "static/media/energyTypeCloseIcon.71e48d1c.svg";